module.exports = __webpack_public_path__ + "static/media/test17.8103f819.jpeg";